import React, { useState } from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  TablePagination,
} from '@mui/material';
import { useAuthState } from '../../../../../contexts/AuthContext';
import { toast } from 'react-toastify';

import api from '../../../../../api/api';
import Row from './Rows/Row';
import CadCliche from './CadCliche/CadCliche';
import VisualizarImagem from './VisualizarImagem/VisualizarImagem';
import Spinner from '../../../../../components/Spinner/Spinner';
import AdiaCliche from './AdiaCliche/AdiaCliche';
export default function TabelaResultados({
  listaOrdens,
  atualizaStatus,
  cadastraCodCliche,
  adiarCliche,
  enviarGravacao,
}) {
  const { empresaAtiva } = useAuthState();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [openDialogCadCliche, setOpenDialogCadCliche] = useState(false);
  const [openDialogAdiaCliche, setOpenDialogAdiaCliche] = useState(false);
  const [vendaSelecionada, setVendaSelecionada] = useState('');
  const [chaveSelecionada, setChaveSelecionada] = useState('');
  const [produtoSelecionado, setProdutoSelecionado] = useState('');
  const [matrizSelecionada, setMatrizSelecionada] = useState('');
  const [coresSelecionadas, setCoresSelecionadas] = useState('');

  const [imagemSelecionada, setImagemSelecionada] = useState();
  const [loading, setLoading] = useState(false);
  const [openDialogVisualizaImagem, setOpenDialogVisualizaImagem] =
    useState(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 25));
    setPage(0);
  };

  const abrirDialogCadCliche = (chave, venda, produto, matriz, cores) => {
    setVendaSelecionada(venda);
    setChaveSelecionada(chave);
    setProdutoSelecionado(produto);
    setMatrizSelecionada(matriz);
    setCoresSelecionadas(cores);

    setOpenDialogCadCliche(true);
  };

  const fechaDialogCadCliche = () => {
    setVendaSelecionada(0);
    setChaveSelecionada('');
    setProdutoSelecionado('');
    setOpenDialogCadCliche(false);
  };
  const abrirDialogAdiarCliche = (chave, venda, produto) => {
    setVendaSelecionada(venda);
    setChaveSelecionada(chave);
    setProdutoSelecionado(produto);

    setOpenDialogAdiaCliche(true);
  };
  const fechaDialogAdiaCliche = (venda) => {
    setVendaSelecionada(venda);
    setOpenDialogAdiaCliche(false);
  };

  const fechaDialogVisualizaImagem = () => {
    setOpenDialogVisualizaImagem(false);
    setImagemSelecionada(null);
  };

  const abrirDialogVisualizarImagem = (caixa, cliente) => {
    setLoading(true);
    api
      .post(
        '/imagem/arte',
        { item: caixa, cliente: cliente },
        {
          headers: { banco: empresaAtiva },
        }
      )
      .then(({ data }) => {
        setImagemSelecionada(data.artes[0].imagem);
        setOpenDialogVisualizaImagem(true);
      })
      .catch((err) => {
        toast.error('Imagem não encontrada ');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (loading) {
    return <Spinner />;
  }
  return (
    <Box>
      {listaOrdens ? (
        <CadCliche
          open={openDialogCadCliche}
          onClose={fechaDialogCadCliche}
          vendaSelecionada={vendaSelecionada}
          cadastraCodCliche={cadastraCodCliche}
          atualizaStatus={atualizaStatus}
          chaveSelecionada={chaveSelecionada}
          produtoSelecionado={produtoSelecionado}
          coresSelecionadas={coresSelecionadas}
          matrizSelecionada={matrizSelecionada}
        />
      ) : (
        <></>
      )}
      {imagemSelecionada ? (
        <VisualizarImagem
          onClose={fechaDialogVisualizaImagem}
          openDialogVisualizaImagem={openDialogVisualizaImagem}
          imagemSelecionada={imagemSelecionada}
        />
      ) : (
        <></>
      )}
      {vendaSelecionada ? (
        <AdiaCliche
          open={openDialogAdiaCliche}
          onClose={fechaDialogAdiaCliche}
          vendaSelecionada={vendaSelecionada}
          chaveSelecionada={chaveSelecionada}
          produtoSelecionado={produtoSelecionado}
          adiarCliche={adiarCliche}
        />
      ) : (
        <></>
      )}
      <TableContainer component={Paper}>
        <Table stickyHeader aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell colSpan={2} />
              <TableCell>Pedido</TableCell>
              <TableCell>Emissão</TableCell>
              <TableCell>Entrega</TableCell>
              <TableCell>Cliente</TableCell>
              <TableCell>Caixa</TableCell>
              <TableCell>Matriz</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {listaOrdens ? (
              listaOrdens.length > 0 ? (
                listaOrdens
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((ordem, index) => {
                    return (
                      <Row
                        ordem={ordem}
                        key={index}
                        abrirDialogCadCliche={abrirDialogCadCliche}
                        abrirDialogAdiarCliche={abrirDialogAdiarCliche}
                        abrirDialogVisualizarImagem={
                          abrirDialogVisualizarImagem
                        }
                        enviarGravacao={enviarGravacao}
                      />
                    );
                  })
              ) : (
                <></>
              )
            ) : (
              <></>
            )}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={listaOrdens.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </Box>
  );
}
